"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlagsContext = useFlagsContext;
const react_1 = require("react");
const context_1 = require("../context");
function useFlagsContext() {
    return (0, react_1.useContext)(context_1.FlagsContext);
}
//# sourceMappingURL=use-flags-context.hook.js.map